import { RmsAccountDetails } from '@/ui/features/accounts/RmsAccountDetails';
import { useAccountSlideoutAdditionalMenuItems } from '@/ui/features/accounts/hooks/useAccountSlideoutAdditionalMenuItems';
import { OrganizationsPanel } from '@juvare/contact-management/ui/features/organizations';
import React from 'react';

export const OrganizationsPage: React.FC = () => {
    const { getAccountAdditionalMenuItems } = useAccountSlideoutAdditionalMenuItems();

    return (
        <OrganizationsPanel
            customMemberSlideoutMenuItems={getAccountAdditionalMenuItems}
            customMemberDetailsComponent={RmsAccountDetails}
        />
    );
};
